export default function DSA_Greedy_Algorithms() {
  return <div>DSA_Greedy_Algorithms Component</div>;
}
